<template>
  <div class="kingdom-card" :class="{ 'is-compact': compact }" @click="$emit('open')">
    <div class="kingdom-card__head">
      <div class="kingdom-card__title">{{ title }}</div>
      <button type="button" class="kingdom-card__x" title="删除王国" @click.stop="$emit('remove')">×</button>
    </div>
    <div v-if="tags.length" class="kingdom-card__names" @click.stop>
      <button
        v-for="tag in tags"
        :key="tag.code"
        type="button"
        class="name-chip"
        :class="{ 'is-on': picked[tag.code] }"
        @click="$emit('pick', tag.code)"
      >
        <i :style="{ background: tag.color }" />
        <span>{{ tag.name }}</span>
        <b v-if="tag.star">★</b>
      </button>
    </div>
    <div ref="el" class="kingdom-card__chart" />
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  name: 'KingdomThumb',
  props: {
    compact: { type: Boolean, default: false },
    title: { type: String, default: '' },
    dates: { type: Array, default: () => [] },
    series: { type: Array, default: () => [] },
    tags: { type: Array, default: () => [] },
    picked: { type: Object, default: () => ({}) }
  },
  data() {
    return { chart: null }
  },
  watch: {
    series: { deep: true, handler() { this.draw() } },
    dates() { this.draw() },
    tags() { this.$nextTick(() => this.draw()) }
  },
  mounted() {
    this.draw()
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    this.chart = null
  },
  methods: {
    draw() {
      const el = this.$refs.el
      if (!el) return
      if (!this.chart) this.chart = echarts.init(el)
      const dates = this.dates || []
      const series = (this.series || []).map((item) => ({
        name: item.name,
        type: 'line',
        data: item.values || [],
        connectNulls: false,
        showSymbol: false,
        lineStyle: { color: item.color, width: 2 },
        itemStyle: { color: item.color }
      }))
      this.chart.setOption({
        animation: false,
        grid: { left: 42, right: 10, top: 16, bottom: 24 },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            fontSize: 10,
            color: '#606266',
            formatter: (value) => String(value).slice(5)
          },
          axisLine: { lineStyle: { color: '#d5e3f2' } }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontSize: 10,
            color: '#606266',
            formatter: (value) => `${value}%`
          },
          splitLine: { show: false }
        },
        series
      }, true)
      this.chart.resize()
    }
  }
}
</script>

<style lang="scss" scoped>
.kingdom-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 240px;
  padding: 8px 8px 4px;
  border: 1px solid #d7e6f5;
  border-radius: 8px;
  background: #fff;
  text-align: left;
  cursor: pointer;
}
.kingdom-card:hover { border-color: #409eff; }
.kingdom-card.is-compact {
  width: 320px;
  height: 168px;
  min-height: 0;
  .kingdom-card__chart { flex: 1 1 72px; min-height: 72px; }
}
.kingdom-card__head {
  display: flex;
  align-items: center;
  gap: 6px;
}
.kingdom-card__title {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 700;
  color: #1f4e79;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.kingdom-card__x {
  flex: none;
  width: 18px;
  height: 18px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: #909399;
  font-size: 16px;
  line-height: 18px;
  cursor: pointer;
}
.kingdom-card__x:hover { color: #f25c54; background: #fff1f0; }
.kingdom-card__names {
  display: flex;
  flex: none;
  flex-wrap: wrap;
  gap: 2px 4px;
  max-height: 44px;
  overflow: auto;
}
.name-chip {
  height: 22px;
  padding: 0 4px;
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border: 1px solid #d7e6f5;
  border-radius: 4px;
  background: #fff;
  color: #1f4e79;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  i { width: 6px; height: 6px; border-radius: 50%; flex: none; }
  b { color: #e10600; font-size: 12px; }
}
.name-chip.is-on { background: #ecf5ff; border-color: #409eff; }
.kingdom-card__chart { flex: 1; min-height: 190px; }
</style>
